import { Component } from '@angular/core';
import {MatTableModule} from '@angular/material/table';


interface ReviewSummary {
  review: string;
  totalOrig: number;
  totalPrep: number;
  screen1Orig: number;
  screen1Prep: number;
  screen2Orig: number;
  screen2Prep: number;
}

@Component({
  selector: 'app-introduction-studies',
  imports: [MatTableModule],
  templateUrl: './introduction-studies.component.html',
  styleUrl: './introduction-studies.component.scss'
})
export class IntroductionStudiesComponent {
  displayedColumns: string[] = [
    'review',
    'totalOrig',
    'totalPrep',
    'screen1Orig',
    'screen1Prep',
    'screen2Orig',
    'screen2Prep'
  ];

  reviewsData: ReviewSummary[] = [
    {
      review: 'Review I (Physiotherapy)',
      totalOrig: 4662,
      totalPrep: 4501,
      screen1Orig: 185,
      screen1Prep: 167,
      screen2Orig: 75,
      screen2Prep: 69
    },
    {
      review: 'Review II (Endometrial disorders)',
      totalOrig: 4366,
      totalPrep: 4366,
      screen1Orig: 228,
      screen1Prep: 211,
      screen2Orig: 148,
      screen2Prep: 148
    }
  ];
}
